export const TRANSITION_FOCUS_DELAY = 450;

// Unit options for different contexts - kept together to prevent drift
export const CONSTITUENT_UNITS = ["mg", "mcg", "g"];
export const BLEND_TOTAL_UNITS = ["mg", "mcg", "g", "ml"];
export const INGREDIENT_UNITS = ["mg", "mcg", "g", "IU", "ml"];

// Combobox blur delay - time to wait before checking if focus left the container
export const COMBOBOX_BLUR_DELAY = 150;

/**
 * Generate a unique ID for dropdown elements (for ARIA attributes)
 * @param {string} prefix - Prefix for the ID (e.g., 'amount-per', 'nutrient')
 * @returns {string} - Unique ID like 'amount-per-dropdown-abc123def'
 */
export function generateDropdownId(prefix) {
  return `${prefix}-dropdown-${Math.random().toString(36).substr(2, 9)}`;
}

export const HINT_TEXTS = {
  CUSTOM_FORMATTING:
    "You can also apply custom formatting in text fields using: <b>**double asterisks for bold**</b> or <i>_underscores for italics_</i>",
  SMART_BOLDING_WITH_FORMATTING:
    "Bolds ingredient names only, not parentheticals. For example: <b>Rice Flour</b> (organic), <b>Soy Lecithin</b>.<br><br>You can also apply custom formatting in text fields using: <b>**double asterisks for bold**</b> or <i>_underscores for italics_</i>",
  EXTRA_LINE_OF_TEXT:
    "You can apply custom formatting using: <b>**double asterisks for bold**</b> or <i>_underscores for italics_</i>. To indent this line, you can type spaces at the beginning of the text.",
};
